export const TransferRoutes = {
  LIST: "/transfers",
  DETAIL: "/transfers/:id",
} as const;
